module.exports = __webpack_public_path__ + "static/media/1_A1_09.703d4b61.png";